// Lib Imports
import React, { memo, useCallback, useRef } from 'react';
import _ from 'lodash';
import { Box, RangeInput, Text, ThemeContext } from 'grommet';
import PropTypes from 'prop-types';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
// Application Imports
import { CropContainer, UploadingBox } from './utils';
const rangeInputTheme = {
  rangeInput: {
    track: {
      height: '5px',
      extend: () => `border-radius: 10px;`
    },
    thumb: {
      color: '#fbab31',
      extend: () => `
      pointer-events: auto;
      `
    },
    extend: () => `pointer-events: none;`
  }
};
const ImageCrop = /*#__PURE__*/memo(({
  image,
  aspect,
  setFieldValue,
  isSubmitting,
  fixedAspect
}) => {
  const ref = useRef();
  const previousVal = useRef(1);
  const onCrop = () => {
    const imageElement = ref?.current;
    const cropper = imageElement?.cropper;
    const {
      cropBoxData,
      canvasData
    } = cropper;
    const imageRef = cropper?.canvas?.children[0];
    let cropData = {
      x: cropBoxData?.left - canvasData?.left,
      y: cropBoxData?.top - canvasData?.top,
      height: cropBoxData?.height,
      width: cropBoxData?.width,
      imageWidth: imageRef?.width,
      imageHeight: imageRef?.height,
      imageNaturalWidth: imageRef?.naturalWidth,
      imageNaturalHeight: imageRef?.naturalHeight
    };
    setFieldValue('imageRef', imageRef);
    setFieldValue('croppedAreaPixels', cropData);
  };
  const handleZoom = useCallback(val => {
    ref.current.cropper.zoom(val);
  }, []);
  const debouncedOnCrop = _.debounce(onCrop, 500);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "14px",
    margin: {
      bottom: 'small'
    }
  }, "Crop Image"), /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(CropContainer, {
    disabled: isSubmitting
  }, isSubmitting && /*#__PURE__*/React.createElement(UploadingBox, {
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    size: "large"
  }, "Please Wait...")), /*#__PURE__*/React.createElement(Cropper, {
    style: {
      height: '100%'
    },
    src: URL.createObjectURL(image),
    initialAspectRatio: aspect,
    aspectRatio: fixedAspect ? aspect : NaN,
    viewMode: 0,
    guides: true,
    minCropBoxHeight: 40,
    minCropBoxWidth: 40,
    background: false,
    responsive: true,
    movable: false,
    scalable: false,
    zoomable: true,
    zoomOnWheel: false,
    autoCropArea: 1,
    crop: debouncedOnCrop,
    checkOrientation: false // https://github.com/fengyuanchen/cropperjs/issues/671
    ,
    ref: ref
    // zoom={({ detail: { ratio, oldRatio, originalEvent } }) => {
    //   value = +document.getElementById('dynamicRange').getAttribute('value') || 0.1;
    //   if (value > 0 && value < 2 && originalEvent) {
    //     const meter = document.getElementById('test');
    //     if (oldRatio < ratio) {
    //       width = +meter.getAttribute('width') + 25.999999999999;
    //       value += 0.1;
    //     } else {
    //       width = +meter.getAttribute('width') - 25.999999999999;
    //       value -= 0.1;
    //     }
    //     if (width >= 0 && width <= 560) {
    //       meter.setAttribute('width', width);
    //       meter.setAttribute(
    //         'style',
    //         `position: absolute;background: #fbab31; width:${
    //           width + 'px'
    //         };height:6.5px;z-index:10;top: 10.5px;left: 0px`,
    //       );
    //     }
    //     previousVal.current = Math.abs(value);
    //     document.getElementById('dynamicRange').defaultValue= value;
    //     document.getElementById('dynamicRange').setAttribute('value', value);
    //   }
    // }}
  }), /*#__PURE__*/React.createElement(Box, {
    margin: {
      vertical: 'small'
    }
  }, /*#__PURE__*/React.createElement(ThemeContext.Extend, {
    value: rangeInputTheme
  }, /*#__PURE__*/React.createElement(RangeInput
  // style={{
  //   position: 'absolute',
  //   top: '0px',
  //   left: '0px',
  // }}
  , {
    step: 0.1,
    min: 0,
    max: 2,
    onChange: event => {
      const debounceCalculate = _.debounce(handleZoom, 100);
      // let width;
      // const meter = document.getElementById('test');

      if (previousVal?.current < event.target.value) {
        // width = +meter.getAttribute('width') + 25.999999999999;
        debounceCalculate(0.1);
      } else {
        // width = +meter.getAttribute('width') - 25.999999999999;
        debounceCalculate(-0.1);
      }
      previousVal.current = Math.abs(event.target.value);
      // meter.setAttribute('width', width);
      // meter.setAttribute(
      //   'style',
      //   `position: absolute;background: #fbab31; width:${
      //     width + 'px'
      //   };height:6.5px;z-index:10;top: 10.5px;left: 0px`,
      // );
    }
  }))))));
});

ImageCrop.propTypes = {
  image: PropTypes.any,
  aspect: PropTypes.number,
  setFieldValue: PropTypes.func,
  isSubmitting: PropTypes.bool,
  fixedAspect: PropTypes.bool
};
ImageCrop.displayName = 'ImageCrop';
export default ImageCrop;